import { render, staticRenderFns } from "./PlayerMiddle.vue?vue&type=template&id=198cca81&scoped=true&"
import script from "./PlayerMiddle.vue?vue&type=script&lang=js&"
export * from "./PlayerMiddle.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMiddle.vue?vue&type=style&index=0&id=198cca81&scoped=true&lang=scss&"
import style1 from "./PlayerMiddle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198cca81",
  null
  
)

export default component.exports